import { Location } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import {
  SocietiesService,
  Society,
  StringUtils,
  UserService,
} from '@pwc-bei/common';
import { AuthenticationService } from '@pwc-bei/security';
import { ModalComponent } from '@pwc-bei/ui';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { first } from 'rxjs/operators';
import { EAccessPlanVariable } from 'src/app/enum/access-plan-variable';
import { ApplicationConfigurationService } from 'src/app/services/application-configuration.service';
import { AuthenticationUtilsService } from 'src/app/services/authentication-utils.service';
import { SocietySelectionUtils } from 'src/app/utils/society-selection-utils';
import { ToastUtils } from 'src/app/utils/toast-utils';
import { environment } from 'src/environments/environment';
import { CategoryRequestEnum } from '../../enum/CategoryRequestEnum';
import { RequestTypeEnum } from '../../enum/RequestTypeEnum';
import { HelpDeskResource } from '../../models/api/helpDesk-resource';
import { HelpDesk } from '../../models/helpDesk';
import { HelpDeskService } from '../../service/help-desk.service';
import { RoutePath } from 'src/app/enums/route-path.enum';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-help-desk-bandi',
    templateUrl: './call-help-desk.component.html',
    styleUrls: ['./call-help-desk.component.scss'],
    standalone: false
})
export class HelpDeskComponent implements OnInit, AfterViewInit {
  public StringUtils = StringUtils;
  invalidCCEmail = false;

  faChevronLeft = faChevronLeft;

  public isUploadReady = true;

  requestTypes = Object.keys(DefaultRequestTypeEnum)
    .filter(
      (key) =>
        environment.techSupportRequestEnabled || key != 'TECH_SUPPORT_REQUEST',
    )
    .map((key) => ({ key, label: DefaultRequestTypeEnum[key] }));
  categoryRequests = Object.keys(CategoryRequestEnum)
    .filter((key) => {
      if (
        key !== 'SURVEY_ESG_SUPPORT' &&
        key !== 'VCF_ENGAGEMENT_LETTER' &&
        key !== 'VCF_BILLING' &&
        key !== 'VCF_SUPPORT' &&
        key !== 'ACCESS_PROBLEMS'
      ) {
        return true;
      } else if (
        environment.vcfEnabled &&
        (key == 'VCF_ENGAGEMENT_LETTER' ||
          key == 'VCF_BILLING' ||
          key == 'VCF_SUPPORT')
      ) {
        return true;
      } else if (environment.esgEnabled && key == 'SURVEY_ESG_SUPPORT') {
        return true;
      }
      return false;
    })
    .map((key) => ({ key, label: CategoryRequestEnum[key] }));

  phoneRegEx = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
  phoneErrors: boolean = true;

  helpDeskForm: HelpDeskResource = {
    id: null,
    nameAndSurname: null,
    email: null,
    ccEmail: null,
    phone: null,
    requestType: null,
    categoryRequest: null,
    objectRequest: null,
    message: null,
    attachment: null,
    filename: null,
    creationDate: null,
    code: null,
    origin: 'B2C',
    societyId: null,
    selected: false,
  };

  helpdesk: HelpDesk[] = [];

  RequestTypeEnum = RequestTypeEnum;
  CategoryRequest = CategoryRequestEnum;

  @ViewChild('confirmTechRequest') confirmTechRequest: ModalComponent;
  @ViewChild('confirmUpgrade') confirmUpgrade: ModalComponent;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private helpDeskService: HelpDeskService,
    private toastr: ToastrService,
    private ngxLoader: NgxUiLoaderService,
    private societiesService: SocietiesService,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private applicationConfigurationService: ApplicationConfigurationService,
    private authenticationUtilsService: AuthenticationUtilsService,
    private location: Location,
    private translateService: TranslateService
  ) { }

  isFormValid(): boolean {
    return (
      !StringUtils.isEmpty(this.helpDeskForm.nameAndSurname) &&
      !StringUtils.isEmpty(this.helpDeskForm.email) &&
      this.ccEmailValidator() &&
      !StringUtils.isEmpty(this.helpDeskForm.phone) &&
      !this.phoneErrors &&
      !StringUtils.isEmpty(this.helpDeskForm.requestType) &&
      !StringUtils.isEmpty(this.helpDeskForm.objectRequest) &&
      this.helpDeskForm.objectRequest.length <= 40 &&
      ((this.helpDeskForm.requestType.toString() === 'PLATFORM_REQUEST' &&
        !StringUtils.isEmpty(this.helpDeskForm.categoryRequest)) ||
        this.helpDeskForm.requestType.toString() === 'TECH_SUPPORT_REQUEST') &&
      this.isStringEmpty(this.helpDeskForm.message)
    );
  }

  selectedPlan: string = null;
  selectedPlanEnabled: boolean = false;
  enabledPlans: string[] = ['premium', 'plus'];

  ngOnInit(): void {
    this.route.queryParams.subscribe((res) => {
      if (res && res.selectedPlan) {
        this.selectedPlan = res.selectedPlan;
      }
    });

    if (this.selectedPlan && this.enabledPlans.includes(this.selectedPlan)) {
      // Enable plan view
      this.selectedPlanEnabled = true;
      // Check if the current plan and the input are different
      this.checkCurrentPlan();

      const PLATFORM_REQUEST: any = Object.keys(RequestTypeEnum).filter(
        (x) => RequestTypeEnum[x] == RequestTypeEnum.PLATFORM_REQUEST,
      )[0];
      const UPGRADE_PLAN_PLUS: any = Object.keys(CategoryRequestEnum).filter(
        (x) => CategoryRequestEnum[x] == CategoryRequestEnum.UPGRADE_PLAN_PLUS,
      )[0];
      const UPGRADE_PLAN_PREMIUM: any = Object.keys(CategoryRequestEnum).filter(
        (x) =>
          CategoryRequestEnum[x] == CategoryRequestEnum.UPGRADE_PLAN_PREMIUM,
      )[0];

      if (this.selectedPlan === 'premium') {
        this.helpDeskForm.objectRequest = 'UPGRADE_PLAN_PREMIUM';
        this.helpDeskForm.message = 'UPGRADE_PLAN_PREMIUM';
        this.helpDeskForm.requestType = PLATFORM_REQUEST;
        this.helpDeskForm.categoryRequest = UPGRADE_PLAN_PREMIUM;
      } else if (this.selectedPlan === 'plus') {
        this.helpDeskForm.objectRequest = 'UPGRADE_PLAN_PLUS';
        this.helpDeskForm.message = 'UPGRADE_PLAN_PLUS';
        this.helpDeskForm.requestType = PLATFORM_REQUEST;
        this.helpDeskForm.categoryRequest = UPGRADE_PLAN_PLUS;
      }
    } else {
      // TODO : Remove upgrade plan elements
      this.categoryRequests = this.categoryRequests.filter((cr) => {
        return (
          cr.key != 'UPGRADE_PLAN_PLUS' && cr.key != 'UPGRADE_PLAN_PREMIUM'
        );
      });
    }

    // if not direct channel, remove ASSESSMENT_COE_SUPPORT
    if (!environment.directChannel) {
      this.categoryRequests = this.categoryRequests.filter((cr) => {
        return (
          cr.key != 'ASSESSMENT_COE_SUPPORT'
        );
      });
    }

    // let applicationConfig: ApplicationConfiguration = {
    //   configuration: ApplicationConfigurationEnum.TECH_SUPPORT,
    //   value: null,
    // };

    // this.applicationConfigurationService.findConfiguration(applicationConfig).subscribe(res => {
    //   if (res) {
    //     this.requestTypes = Object.keys(RequestTypeEnum).map(key => ({ key, label: RequestTypeEnum[key] }));
    //   }
    // })

    const selectedSociety = sessionStorage.getItem('society');
    const society: Society = JSON.parse(selectedSociety);

    // this.societiesService.currentSociety$.subscribe(society => {
    if (society == null) {
      this.userService
        .getSocietiesForGroupCodes(SocietySelectionUtils.GROUP_CODES)
        .pipe(first())
        .subscribe((societies: Society[]) => {
          if (societies.length > 1) {
            this.router.navigate([
              RoutePath.BANDI,
              RoutePath.TAX_BREAK,
              RoutePath.SOCIETY_SELECTION,
            ]);
          } else {
            if (societies.length > 0) {
              this.societiesService.setSociety(societies[societies.length - 1]);
            }
          }
        });
    } else {
      this.societiesService.setSociety(society);
    }
    // });

    this.authenticationService.dataUser().subscribe((user: any) => {
      this.helpDeskForm.nameAndSurname = user.firstName + ' ' + user.lastName;
      this.helpDeskForm.email = user.email;

      const widgetLiveAssistantEnabled = user.liveAssistantWidgetVisible;

      if (!widgetLiveAssistantEnabled) {
        this.categoryRequests = this.categoryRequests.filter(
          (category) => category.key !== 'VIDEOCONFERENCE_SUPPORT',
        );
      }
    });
  }

  ngAfterViewInit(): void {
    window.scrollTo(0, 0);
  }

  goBack() {
    this.location.back();
  }

  goToFaq() {
    this.router.navigate([RoutePath.BANDI, RoutePath.FAQ]);
  }

  isStringEmpty(str: string): boolean {
    return str != null && str != '';
  }

  phoneAllowedInput(event) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)
      && event.key !== '+' && event.key !== '-') {
      event.preventDefault();
      return false;
    }
    return true;
  }

  /**
   * Phone Validator based on regex and first symbol is +
   * @param event
   * @returns
   */
  phoneValidator(event) {
    if (this.phoneRegEx.test(event.target.value)) {
      this.phoneErrors = false;
      return false;
    } else {
      this.phoneErrors = true;
      return true;
    }
  }

  ccEmailValidator(): boolean {
    if (this.helpDeskForm.ccEmail && this.helpDeskForm.ccEmail != '') {
      if (
        !this.helpDeskForm.ccEmail.match(
          '^([a-z][a-z0-9_.]+@([a-z0-9-]+.)+[a-z]{2,6}(,)*)+$',
        )
      ) {
        this.invalidCCEmail = true;
        return false;
      }
    }
    this.invalidCCEmail = false;
    return true;
  }

  // handle file selection
  handleUpload(event) {
    this.isUploadReady = false;
    const file = event.target.files[0];
    if (!file) {
      this.isUploadReady = true;
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (file.size < 100000000) {
        this.helpDeskForm.attachment = reader.result.toString().split(',')[1];
        this.helpDeskForm.filename = file.name;
      } else {
        this.toastr.error(
          this.translateService.instant('toast.error.max-file-size-100-mb'),
          ToastUtils.TITLE_ERROR,
        );
        this.isUploadReady = false;
        return;
      }
      const ext = file.name.split('.')[file.name.split('.').length - 1];
      switch (ext.toLowerCase()) {
        case 'pdf':
        case 'doc':
        case 'docx':
        case 'xls':
        case 'xlsx':
        case 'zip':
        case 'xml':
        case 'jpeg':
        case 'jpg':
        case 'png':
        case 'tiff':
        case 'csv':
        case 'txt':
        case 'mp4':
          break;
        default:
          this.toastr.error(this.translateService.instant('toast.error.file-not-valid'), ToastUtils.TITLE_ERROR);
          this.isUploadReady = false;
          return;
      }
      this.isUploadReady = true;
    };
  }

  sendRequest() {
    if (this.helpDeskForm.requestType.toString() === 'TECH_SUPPORT_REQUEST') {
      this.confirmTechRequest.open();
    } else {
      this.save();
    }
  }

  onConfirm() {
    this.save();
  }

  private save() {
    if (!this.isFormValid()) {
      return;
    }
    this.ngxLoader.start();
    this.helpDeskForm.creationDate = new Date();
    if (this.helpDeskForm.ccEmail === '') {
      this.helpDeskForm.ccEmail = null;
    }

    this.societiesService.currentSociety$
      .pipe(first())
      .subscribe((response) => {
        this.helpDeskForm.societyId = response.id;

        this.helpDeskService
          .sendHelpRequest(this.helpDeskForm)
          .pipe(first())
          .subscribe({
            next: () => {
              this.ngxLoader.stop();
              if (this.selectedPlan) {
                this.confirmUpgrade.open();
              } else {
                this.toastr.success(this.translateService.instant('toast.success.mail-success'), ToastUtils.TITLE_SUCCESS);
                this.router.navigate([
                  RoutePath.BANDI,
                  RoutePath.HELPDESK,
                  RoutePath.HELPDESK_SUCCESSFUL_REQUEST,
                ]);
              }
            }, error: (error) => {
              this.ngxLoader.stop();
              this.toastr.error(
                this.translateService.instant('toast.error.try-later'),
                ToastUtils.TITLE_ERROR,
              );
            },
          });
      });
  }

  checkCurrentPlan(): void {
    const isUserSmart = this.authenticationUtilsService.getAccessPlan(
      EAccessPlanVariable.IS_USER_SMART,
    );
    const isUserPlus = this.authenticationUtilsService.getAccessPlan(
      EAccessPlanVariable.IS_USER_PLUS,
    );

    if (!isUserSmart && !isUserPlus) {
      this.router.navigate([RoutePath.BANDI, RoutePath.BASE]);
    }
  }

  onClickOkUpgrade(): void {
    this.router.navigate([RoutePath.BANDI, RoutePath.HELPDESK_LIST]);
  }
}

enum DefaultRequestTypeEnum {
  PLATFORM_REQUEST = 'Richiesta di assistenza su Piattaforma',
  TECH_SUPPORT_REQUEST = 'Richieste di assistenza tecnico - specialistico (a pagamento)',
}
